
import React from "react";
import { ExternalLink } from "lucide-react";
import { useLocation } from "react-router-dom";

const Footer: React.FC = () => {
  const location = useLocation();
  const isAdminPage = location.pathname.includes('/admin/');
  
  if (isAdminPage) {
    return null;
  }
  
  return (
    <footer className="py-4 px-4 border-t mt-auto bg-gradient-to-r from-indigo-50 to-purple-50">
      <div className="container mx-auto flex justify-center items-center text-sm text-gray-500">
        <span>Powered by</span>
        <a 
          href="https://www.n-micro.ca" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center ml-1 text-primary hover:underline"
        >
          N-Micro IT Solutions Inc.
          <ExternalLink className="h-3 w-3 ml-1" />
        </a>
      </div>
      <div className="container mx-auto text-center mt-2 text-xs text-gray-500">
        &copy; 2025 Grade Test Pro. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
